<template>
  <div class="get-token">正在获取授权结果，请稍后...</div>
</template>

<script>
let toastTips;
import { getData } from "../Interface/http.js";
export default {
  name: "GetToken",
  data() {
    return {};
  },
  mounted() {
    toastTips=this.$toast.loading({ message: '授权中...', forbidClick: true });
    let a = window.location.href;
    if (a.indexOf("?") != -1) {
      let b = a.split("?")[1];
      if (b.indexOf("&") != -1) {
        let c = b.split("&");
        c.map(res => {
          if (res.split("=")[0] == "code") {
            this.token = res.split("=")[1];
          }
        });
      } else {
        this.token = b.split("=")[1];
      }
      if (this.token != "") {
        localStorage.setItem("token_me", this.token);
      } else {
        localStorage.setItem("token_me", "-1");
      }
    }
    if (localStorage.getItem("token_me") != "-1") {
      this.getCode();
    } else {
      //this.$toast("登录失败");
      this.$store.commit("UPDATEATBINDEX", { tag: 0 });
      this.$router.push({ name: "home" });
    }
  },
  methods: {
    getCode() {
      let code = localStorage.getItem("token_me");
      getData("/oauth/callback/wechat", {
        code: code
      })
        .then(res => {
          let start = localStorage.getItem("startPage");
          this.$store.commit("USERMESSAGE", { userInfo: res.data });
          localStorage.setItem("token", res.data.token);
          if(!res.data.token) {
           return;
          }
          toastTips.clear();
          if (start == "myCenter") {
            this.$store.commit("UPDATEATBINDEX", { tag: 4 });
            this.$router.push({ name: "mycenter" });
          }else if(start == "home"){
            this.$router.push({ name: "home" });
          }else if(start == "postSuc"){
            this.$router.push({ name: "postSuc" });
          }else if (start == "about"){
            window.location.href = localStorage.getItem("pageparams");
            //this.$router.push({ name: "about" });
          }else if (start == "TabAbout"){
            this.$router.push({ name: "TabAbout" })
          } else if (start == "postMessage") {
            this.$store.commit("UPDATEATBINDEX", { tag: 2 });
            this.$router.push({ name: "post" });
          }else {
            this.$store.commit("UPDATEATBINDEX", { tag: 0 });
            this.$router.push({ name: "home" });
          }
        }).catch(()=>{
          
        })
    }
  }
};
</script>

<style>
</style>
